<div cdkDrag cdkDragRootElement=".ant-modal-content">
  <div *nzModalTitle class="inline" cdkDragHandle>
    <ng-container *ngIf="!nzData.IsRecurring"> Delete event </ng-container>
    <ng-container *ngIf="nzData.IsRecurring">
      Delete recurring event(s)
    </ng-container>
    <div class="actions">
      <nz-icon
        nzType="shrink"
        nzTheme="outline"
        class="button"
        (click)="modal.toggle()"
        *ngIf="!modal.minimized"
      />
      <nz-icon
        nzType="arrows-alt"
        nzTheme="outline"
        class="button"
        (click)="modal.toggle()"
        *ngIf="modal.minimized"
      />
      <nz-icon
        nzType="close-circle"
        (click)="close()"
        class="button cancel"
        nzTheme="outline"
      />
    </div>
  </div>

  <div *ngIf="!nzData.IsRecurring">Are you sure ?</div>
  <div *ngIf="nzData.IsRecurring">
    <nz-radio-group
      [(ngModel)]="deleteMode"
      nzButtonStyle="solid"
      style="width: 100%; display: inline-flex"
    >
      <label
        nz-radio-button
        nzValue="series"
        style="text-align: center; white-space: nowrap"
        >Series (All in this group)</label
      >
      <label
        nz-radio-button
        nzValue="current"
        style="width: 25%; text-align: center"
        >Current</label
      >
      <label
        nz-radio-button
        nzValue="past"
        style="width: 25%; text-align: center"
        >Past</label
      >
      <label
        nz-radio-button
        nzValue="future"
        style="width: 25%; text-align: center"
        >Future</label
      >
    </nz-radio-group>
  </div>

  <div *nzModalFooter cdkDragHandle>
    <button nz-button nzType="default" (click)="close()">Cancel</button>
    <button nz-button nzType="primary" (click)="submit()">Confirm</button>
  </div>
</div>
